// extracted by mini-css-extract-plugin
module.exports = {"loader":"Spinner_loader__RgHix","load6":"Spinner_load6__7NbrK","round":"Spinner_round__Q-mHm"};